"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
require("ayvri-std/lib/polyfill");
var screenfull = require("screenfull");
require("whatwg-fetch");
var preconditions_ts_1 = require("preconditions-ts");
var redux_1 = require("redux");
var redux_thunk_1 = require("redux-thunk");
var comment_1 = require("../../components/comment");
var follow_1 = require("../../components/follow");
var profile_1 = require("../../components/profile");
var env_1 = require("../../helpers/env");
var scene_1 = require("../../helpers/scene");
var wasm_1 = require("../../helpers/wasm");
var rendering_1 = require("../../pages/rendering");
var login_1 = require("../../reducers/login");
var user_1 = require("../../reducers/user");
var user_geo_1 = require("../user-geo");
var _1 = require("./");
var like_1 = require("./like");
var scene_2 = require("./scene");
function installFullscreenListener(viewer, viewerContainer) {
    // Trigger Fullscreen once the user interacts with the Viewer
    viewerContainer.addEventListener('click', function (e) {
        if (screenfull.isEnabled) {
            viewer.setFullscreen({ fullscreen: true });
        }
        else {
            // @NOTE: Safari on iOS does not (yet) support the Fullscreen API. See https://caniuse.com/#feat=fullscreen.
            //        As a workaround, make the Viewer element fill the entire viewport.
            location.hash = 'fullscreen';
        }
    }, true);
    // Remove any existing hash value when a user first navigates to this page
    // @NOTE: Without this, visiting '<someSceneURL>#fullscreen' would break because onhashchange would never fire
    history.replaceState(null, null, ' ');
    // Modifying the hash to trigger fullscreen means that the back button will undo the hash modification.
    window.onhashchange = function () {
        if (location.hash === '#fullscreen') {
            viewerContainer.classList.add('fullscreen');
        }
        else {
            viewerContainer.classList.remove('fullscreen');
        }
    };
}
var preloadedState = window.__PRELOADED_STATE__;
delete window.__PRELOADED_STATE__;
delete preloadedState.___;
var store = redux_1.createStore(redux_1.combineReducers({ user: user_1.user, loginUrl: login_1.loginUrlReducer, scene: scene_2.scene, profile: profile_1.profile, follow: follow_1.followState, comments: comment_1.comments, likes: like_1.likes }), preloadedState, redux_1.applyMiddleware(redux_thunk_1.default));
// Query for our local units (metric/imperial)
var unitsPromise = user_geo_1.userGeo().getUnits();
// the ayvri_globe_enabled feature flag is king, i.e. if it is set to true, then
// nothing else is taken into consideration and ayvri globe renderer is used by default
// additionally, no prompts are shown to enable a user to opt in
var hasWasm = wasm_1.hasWebAssembly();
var globeForceOn = !!window.features.ayvri_globe_enabled;
var globeEnabled = globeForceOn || scene_1.getBetaGlobeSetting();
var globeSetting = {
    allowGlobeToggle: hasWasm && !globeForceOn && !!window.features.allow_globe_toggle,
    globeEnabled: globeEnabled && hasWasm,
    getBetaGlobeSetting: scene_1.getBetaGlobeSetting,
    setBetaGlobeSetting: scene_1.setBetaGlobeSetting,
};
rendering_1.hydrateToRoot(_1.SceneJSX(store, window.features, globeSetting));
window.addEventListener('DOMContentLoaded', function () { return runPlayer(); });
function runPlayer() {
    return __awaiter(this, void 0, void 0, function () {
        var playerScene, viewer, viewerContainer, globeOptions;
        return __generator(this, function (_a) {
            playerScene = scene_1.toPlayerScene(window.sceneJson);
            viewer = preconditions_ts_1.required(window.AyvriViewer, 'viewer not loaded');
            viewerContainer = preconditions_ts_1.required(document.getElementById('player'), 'unable to player the html element to hold the player');
            globeOptions = globeEnabled ? { enableAyvriGlobe: true, enableCesiumGlobe: false } : {};
            viewer
                .initialize(viewerContainer, env_1.env().viewerAssetPath(), playerScene, __assign({ features: window.features }, globeOptions))
                .then(function () {
                if (window.isMobile) {
                    installFullscreenListener(viewer, viewerContainer);
                }
                unitsPromise.then(function (units) { return viewer.setUnits({ units: units }); });
            });
            return [2 /*return*/];
        });
    });
}
